<div #chartElem class="chartDiv">
    <div class="linechart"></div>
</div>
<div style="display:flex;justify-content: space-between;">
    <div style="margin-left:20px">{{selectedComponents[0].componentName}}</div>
    <div style="margin-right: 30px;">{{selectedComponents[1].componentName}}</div>
</div>